import { ConfigStore } from "../../store/modules/config";
import { CatalogStore } from "../../store/modules/catalog";
import { Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Vue from "vue";

/**
 *  Класс для элемента каталога.
 */
export class CatalogIconVue extends Vue {

  /** Входные данные */
  @Prop() baseObject!: any;

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище каталога
 * @returns {CatalogStore}
 */
  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }
}
